import { createContext } from 'react';
let realContext = null;

function getContext() {
  if (!realContext) {
    realContext = createContext(null);

    if (process.env.NODE_ENV !== 'production') {
      realContext.displayName = 'ReactRedux';
    }
  }

  return realContext;
}

export const ReactReduxContext = /*#__PURE__*/new Proxy({}, /*#__PURE__*/new Proxy({}, {
  get(_, handler) {
    const target = getContext(); // @ts-ignore

    return (_target, ...args) => Reflect[handler](target, ...args);
  }

}));
export default ReactReduxContext;